import React from 'react';
import { UseFormRegister } from 'react-hook-form';

import { useAppSelector } from '../../../hooks/hooksRedux';
import { RootState } from '../../../store';

import { defaultBorder, defaultColors } from '../../../styles/style-guide';
import { CheckboxContainer, CheckboxWrapper, ErrorMessage, StyledCheckbox, StyledLabel } from './styleGuide';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label: string;
  error?: string;
  value?: any;
  labelClass?: string;
  register: UseFormRegister<any>;
}

const CustomCheckbox = ({ id, label, value, error, labelClass, register, ...rest }: Props) => {
  const { colors, border } = useAppSelector((state: RootState) => state.styleGuide.data);
  const primaryColors = colors.primary || defaultColors.primary;
  const primaryBorderColors = border.primary || defaultBorder.primary;

  return (
    <CheckboxContainer>
      <CheckboxWrapper>
        <StyledCheckbox
          $hasError={!!error}
          $borderColor={primaryBorderColors}
          type="checkbox"
          value={value}
          {...register(id)}
          {...rest}
        />
        <StyledLabel $colors={primaryColors} labelClass={labelClass}>
          {label}
        </StyledLabel>
      </CheckboxWrapper>
      {!!error && <ErrorMessage>{error}</ErrorMessage>}
    </CheckboxContainer>
  );
};

export { CustomCheckbox };
